import { List } from 'immutable';
import { defaultMemoize } from 'reselect';

import {
    isResourceLoading,
    getResourceTotal,
    getResourcePage,
} from './common';

const isProductUpdatesLoading = defaultMemoize(isResourceLoading);
const getProductUpdatesTotal = getResourceTotal;
const getProductUpdatesPage = getResourcePage;
const getProductUpdates = defaultMemoize(
    (data) => data.get('product_updates', List()),
);

const isFeaturedProductUpdatesLoading = defaultMemoize(isResourceLoading);
const getFeaturedProductUpdates = defaultMemoize(
    (data) => data.get('productUpdates', List()),
);

export {
    isFeaturedProductUpdatesLoading,
    isProductUpdatesLoading,
    getFeaturedProductUpdates,
    getProductUpdatesTotal,
    getProductUpdatesPage,
    getProductUpdates,
};
